import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid p-mt-3"
}
const _hoisted_2 = {
  key: 0,
  class: "p-field p-col-12 p-lg-6"
}
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary node-detail-dialog",
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.hierarchyManagement.modifyHierarchy')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.mode === 'info' ? _ctx.$t('common.ok') : _ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.mode !== 'info')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "kn-button kn-button--primary",
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.node)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metadata, (item, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                (_ctx.mode === 'createRoot' || item.VISIBLE)
                  ? (_openBlock(), _createBlock("div", _hoisted_2, [
                      _createVNode("span", _hoisted_3, [
                        (item.TYPE === 'Date')
                          ? (_openBlock(), _createBlock(_component_Calendar, {
                              key: 0,
                              modelValue: _ctx.node[item.ID],
                              "onUpdate:modelValue": ($event: any) => (_ctx.node[item.ID] = $event),
                              manualInput: true,
                              disabled: _ctx.mode === 'info' || (!item.EDITABLE && _ctx.mode !== 'create')
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                          : (_openBlock(), _createBlock(_component_InputText, {
                              key: 1,
                              class: "kn-material-input",
                              modelValue: _ctx.node[item.ID],
                              "onUpdate:modelValue": ($event: any) => (_ctx.node[item.ID] = $event),
                              modelModifiers: { trim: true },
                              type: item.TYPE === 'Number' ? 'number' : 'text',
                              disabled: _ctx.mode === 'info' || (!item.EDITABLE && _ctx.mode !== 'create') || item.FIX_VALUE
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "disabled"])),
                        _createVNode("label", _hoisted_4, _toDisplayString(item.NAME), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}